(function () {
  const tidy = value => String(value || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim().replace(/^[*•]+\s*/, '');
  const unit = /\d\s*(?:cm\b|mm\b|m\b|inches\b|inch\b|ft\b|["″”])/i;
  const dimension = /^(?:(?:overall|extended|closed|open|reclined|total|sofa|bed|seat|seating|frame|armrest|arm|backrest|back rest|floor to seat|floor to armrest|left|right|corner|chaise|footstool|headboard|footboard)\s+)*(?:width|depth|height|length|size|footprint|diameter|thickness|dimensions?|sleeping area|sleeping surface|w\b|d\b|h\b|l[1-3]?\b)/i;
  const compact = /\d+(?:\.\d+)?\s*(?:cm)?\s*[x×]\s*\d/i;
  const size = /^(?:[1-5]\s*[- ]?seat(?:er|s)(?:\s+(?:sofa|power recliner))?|armchair|arm chair|chair|footstool|small(?:\s+u\s*shape)?|large(?:\s+u\s*shape)?|corner(?:\s+sofa)?|sofa bed)\s*:?(?:\s*\(.*?\))?$/i;
  const prefixSize = /^([1-5]\s*[- ]?seat(?:er|s)(?:\s+(?:sofa|power recliner))?|armchair|arm chair|footstool|small\s+u\s*shape|large\s+u\s*shape)\s*(?:[:–-]\s*|\s+)(.+)$/i;
  const excluded = /^(?:comparing|compare|the\b|our\b|please\b|check\b|measurements are|allow\b|leave\b|find\b|this\b|it\b|with\b|for\b|if\b)/i;

  function extractMeasurements(blocks, title) {
    const groups = [];
    const seen = new Set();
    let heading = '';
    let impliedUnit = '';
    let inDimensions = false;
    let pending = null;
    function flushPending() { if (pending?.values.length) add(pending.label, pending.values.join(' × '), pending.heading); pending = null; }
    function add(label, value, group) {
      label = tidy(label).replace(/\s*[:–-]\s*$/, '');
      value = tidy(value);
      if (!value || !/\d/.test(value)) return;
      const key = [group, label, value].join('|').toLowerCase();
      if (seen.has(key)) return;
      seen.add(key);
      let target = groups.find(item => item.heading === group);
      if (!target) { target = { heading: group, rows: [] }; groups.push(target); }
      target.rows.push({ label: label || 'Dimensions', value });
    }
    for (const block of blocks) {
      const text = tidy(block.text);
      if (!text) continue;
      if (/^l[1-3]$/i.test(text)) { const base = pending?.label.replace(/\s*\(L[1-3]\)$/i, '') || 'Width'; flushPending(); pending = {label: base + ' (' + text + ')', heading, values: []}; continue; }
      if (pending && /^\d/.test(text) && unit.test(text) && text.length < 45) { pending.values.push(text); continue; }
      flushPending();
      if (dimension.test(text) && !/\d/.test(text) && text.length < 65 && !/dimensions?|measurements/i.test(text)) { pending = {label: text, heading, values: []}; continue; }
      if (/dimensions?|measurements|size\s*(?:&|and)\s*fit/i.test(text) && !/\d/.test(text) && text.length < 95) {
        inDimensions = true;
        if (/\bcm\b/i.test(text)) impliedUnit = 'cm';
        if (/\bmm\b/i.test(text)) impliedUnit = 'mm';
        heading = '';
        continue;
      }
      if (size.test(text)) { heading = text.replace(/\s*:\s*$/, ''); continue; }
      if (block.kind === 'heading' && !dimension.test(text) && !compact.test(text) && !unit.test(text)) { heading = ''; inDimensions = false; continue; }
      if (block.kind === 'table') {
        const rows = block.rows.map(row => row.map(tidy)).filter(row => row.some(Boolean));
        const explicitTableUnit = rows.flat().join(' ').match(/\b(cm|mm)\b/i);
        const tableUnit = explicitTableUnit ? explicitTableUnit[1] : impliedUnit;
        const isDimensionTable = /dimensions?|width|depth|height|length/i.test(rows[0]?.join(' ') || '');
        if (!rows.some(row => row.some(cell => unit.test(cell) || compact.test(cell))) && !inDimensions && !isDimensionTable) continue;
        let headers = [];
        for (const row of rows) {
          if (!row.some(cell => /\d/.test(cell))) { headers = row; continue; }
          if (row.length === 2) {
            if ((dimension.test(row[0]) || isDimensionTable || compact.test(row[1])) && (unit.test(row[1]) || tableUnit)) add(row[0], row[1] + (!unit.test(row[1]) && tableUnit ? ' ' + tableUnit : ''), heading);
          } else if (headers.length === row.length) {
            const firstIsLabel = !/^\d+(?:\.\d+)?$/.test(row[0]);
            const label = firstIsLabel ? row[0] : 'Dimensions';
            const values = row.slice(firstIsLabel ? 1 : 0).map((cell, index) => {
              const h = headers[index + (firstIsLabel ? 1 : 0)];
              return (h ? h + ': ' : '') + cell + (!unit.test(cell) && tableUnit ? ' ' + tableUnit : '');
            });
            add(label, values.join(' · '), heading);
          } else {
            const flattened = row.join(' ');
            if (dimension.test(flattened) || compact.test(flattened)) add(row[0], row.slice(1).join(' · '), heading);
          }
        }
        continue;
      }
      if (!text || text.length > 220 || excluded.test(text)) continue;
      const sized = text.match(prefixSize);
      const measure = sized ? tidy(sized[2]) : text;
      if (!(dimension.test(measure) || compact.test(measure) || (sized && /^\d/.test(measure)) || (/^\d/.test(measure) && /[x×]/i.test(measure)))) continue;
      if (!unit.test(measure) && !(inDimensions && impliedUnit && /\d/.test(measure))) continue;
      let label = 'Dimensions';
      let value = measure;
      const colon = measure.indexOf(':');
      if (colon > 0 && colon < 80) { label = measure.slice(0, colon); value = measure.slice(colon + 1); }
      else {
        const split = measure.match(/^([^\d]{2,80}?)\s*[-–:]?\s*(\d.*)$/);
        if (split) { label = split[1]; value = split[2]; }
      }
      if (!unit.test(value) && impliedUnit) value += ' ' + impliedUnit;
      add(label, value, sized ? sized[1] : heading);
    }
    flushPending();
    const lowerTitle = title.toLowerCase();
    const isSet = /\d\s*\+\s*\d|sofa set|sofa range|or\s+3\s*\+/.test(lowerTitle);
    const seat = !isSet && lowerTitle.match(/\b([1-5])\s*[- ]?seater\b/);
    const armchair = !isSet && /armchair|arm chair/.test(lowerTitle);
    const hasSizeGroups = groups.some(group => size.test(group.heading));
    if (hasSizeGroups && (seat || armchair)) {
      return groups.filter(group => {
        if (!size.test(group.heading)) return true;
        if (armchair) return /armchair|arm chair|^chair$/i.test(group.heading);
        return new RegExp('^' + seat[1] + '\\s*[- ]?seater','i').test(group.heading);
      });
    }
    return groups;
  }

  function getBlocks(source) {
    return Array.from(source.querySelectorAll('h1,h2,h3,h4,h5,h6,p,li,table,div')).filter(el => {
      if (el.closest('table') && el.tagName !== 'TABLE') return false;
      if (el.closest('.lmb-sofa-range-links')) return false;
      if (el.tagName === 'DIV' && el.querySelector('div,p,li,table,h1,h2,h3,h4')) return false;
      return !(el.tagName === 'LI' && el.querySelector('p,table,ul,ol'));
    }).flatMap(el => {
      const kind = el.tagName === 'TABLE' ? 'table' : /^H\d$/.test(el.tagName) ? 'heading' : 'text';
      if (kind === 'table') return [{kind, text: el.textContent, rows: Array.from(el.querySelectorAll('tr')).map(tr => Array.from(tr.querySelectorAll('th,td')).map(td => td.textContent))}];
      const copy = el.cloneNode(true);
      copy.querySelectorAll('br').forEach(br => br.replaceWith('||LMB_BREAK||'));
      return copy.textContent.split('||LMB_BREAK||').map(text => ({kind, text}));
    });
  }

  function init(root) {
    root.querySelectorAll('[data-lmb-sofa-measurements]').forEach(aside => {
      if (aside.dataset.measurementsReady) return;
      const source = aside.querySelector('template');
      if (!source) return;
      const groups = extractMeasurements(getBlocks(source.content), aside.dataset.productTitle || '');
      const panel = aside.querySelector('[data-measurement-results]');
      if (groups.length) {
        panel.replaceChildren();
        groups.forEach(group => {
          if (group.heading) {
            const h = document.createElement('h4'); h.className = 'lmb-dimensions__group-title'; h.textContent = group.heading; panel.append(h);
          }
          const list = document.createElement('dl'); list.className = 'lmb-dimensions__grid';
          group.rows.forEach(row => {
            const item = document.createElement('div'); item.className = 'lmb-dimensions__item';
            const label = document.createElement('dt'); label.textContent = row.label;
            const value = document.createElement('dd'); value.textContent = row.value;
            item.append(label, value); list.append(item);
          });
          panel.append(list);
        });
        const caption = aside.querySelector('[data-measurement-caption]'); if (caption) caption.textContent = aside.dataset.caption;
      }
      aside.dataset.measurementsReady = 'true';
    });
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { extractMeasurements };
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
    document.addEventListener('shopify:section:load', event => init(event.target));
  }
})();
